/**
 * Created by sagardesai on 13/07/18.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import {OTSession, OTStreams} from "opentok-react";
import className from "classnames";
import * as actions from "../../actions";
import {TOKBOX_APIKEY} from "../../util/constants";
import Publisher from "../../components/tokbox/Publisher";
import Subscriber from "../../components/tokbox/Subscriber";
import ExitSessionModal from "../../components/modal/ExitSessionModal";
import RequestForPaidGroupSessionModal from "../../components/modal/RequestForPaidGroupSessionModal";
import PrivateSessionInviteModal from "../../components/modal/PrivateSessionInviteModal";
import ReportBroadcastModal from "../../components/modal/ReportBroadcastModal";
import JoinBroadcastConfirmationModal from "../../components/modal/JoinBroadcastConfirmationModal";
import {
    checkValidBroadcast,
    endKickOutCountDownTimer,
    endOTSessionCountdown,
    startKickOutCountdownTimer,
    startOTSessionCountdown,
} from "../../util/broadcast/start_broadcast";
import {
    hideModal,
    isEmpty,
    LogException,
    removeAllModalPopUps,
    showModal,
    updateVideoDimensions,
    vuepayAlert,
    vuePayLog,
} from "../../util/utility";
import {getData, LOGIN, USER_DATA} from "../../util/storage";
import {
    decodeEncryptedIdForBroadcaster,
    formatBroadacastJson,
    getEncryptedIdForBroadcaster,
} from "../../util/broadcast_util";
import {cancelFullScreen, requestFullScreen} from "../../util/broadcast/countdown";
import {getSignalObject, getWalletUserSessionDetails, parseUserDataFromConnection,} from "../../util/broadcast/common";
import {
    cancelPaidGroupRequest,
    cancelPrivateRequest,
    getChangeBroadcastStatus,
    getOneToOneRequestStatus,
    getPaidGroupRequestStatus,
    getPrivateSessionRequestStatus,
    subscribeToFireStoreForOneToOneRequest,
    subscribeToFireStoreForTipGoal,
    unsubscribeToFireStore,
} from "../../util/firebase/firestore";
import {getWalletBalance} from "@practicalcodelabs/moneyblox-dev";
import {updateJWTToken} from "../../util/broadcast/create";
import assets from "../../util/assets";
import {getMoneyBloxCurrentWalletBalance} from "../../assets/libs/MoneyBlox";
import {get as _get} from "lodash";
import ProgressBar from "progressbar.js";
import {ChatComponent, TopSection, ViewerTipComponent, ViewerTipGoalComponent} from "../../components/Video";
import AwaitingModal from "../../components/modal/AwaitingModal";

class ViewBroadcast extends Component {
    constructor(props) {
        super(props);
        this.otSession = React.createRef();

        this.state = {
            api_key: TOKBOX_APIKEY,
            broadcaster: null,
            broadcast_id: null,
            session_id: null,
            token: null,
            signalArray: [],
            video: false,
            audio: false,
            modal: false,
            elapsed_time: "00:00",
            broadcasterLeftSession: false,
            privateSessionInviteModal: false,
            paidGroupRequestModal: false,
            joinBroadcastModal: false,
            inviteSessionModal: false,
            reportBroadcastModal: false,
            isPrivateRequestSent: false,
            isPrivateRequestReceived: false,
            isPaidGroupRequestSent: false,
            isPrivateRequestAccepted: false,
            tempNewBroadcastId: -1,
            private_broadcast_id: -1,
            broadcastModalTitle: "The broadcaster is starting a paid session",
            isTransactionPending: false,
            showLoading: false,
            subscriberAudio: false,
            showSubscriber: false,
            isPoorConnectivity: false,
            isFullScreen: false,
            togglePubSubState: false,
            fullScreenHeight: window.innerHeight,
            videoOriginalHeight: "",
            isPrivateSession: true,
            otherRequestAccepted: false,
            isMessageSend: false,
            tipMessage: null,
            tipAmountSend: '£ 0.00',
            tipGoalData: {
                percentage:0,
                total_contributors:0,
                total_tip_amount_formatted:"0.00"
            },
            tipButtonActive: false,
            tipGoalButtonActive: false,
            liveChatButtonActive: true,
            wallet_balance: "0.00",
            tipGoalMessage: null,
            maximumtipStatus: false,
            tipGoalPurpose: null,
            tipGoalId: null,
            activeRightLayout: 'chat',
            notification: {
                'chat': false,
                'onetoone': false,
                'group': false,
                'tip': false,
                'tipgoal': false
            },
            innerWidth: window.innerWidth
        };

        this.sessionEvents = {
            sessionConnected: () => {
                this.setState({connected: true});
                setTimeout(() => {
                    //charge viewer for broadcast after 2 sec of session connection
                    this.setUpChargeForViewer("constructor");
                    this.setState({
                        // subscriberAudio:true,
                        showLoading: false,
                    });
                }, 2000);

                startOTSessionCountdown((time) => {
                    this.setElapsedTime(time);
                });
            },
            sessionDisconnected: () => {
                this.setState({connected: false});
                endOTSessionCountdown();
                endKickOutCountDownTimer();
            },
        };

        //all the functions used in this component should be listed here for better documentation
        this.setOTSession = this.setOTSession.bind(this);
        this.onErrorReceived = this.onErrorReceived.bind(this);
        this.disconnectOTSession = this.disconnectOTSession.bind(this);
        this.endSession = this.endSession.bind(this);
        this.toggleEndSessionModal = this.toggleEndSessionModal.bind(this);
        this.navigateUserOut = this.navigateUserOut.bind(this);
        this.toggleVideo = this.toggleVideo.bind(this);
        this.toggleAudio = this.toggleAudio.bind(this);
        this.togglePubSub = this.togglePubSub.bind(this);

        updateVideoDimensions();
    }

    toggleRightLayout = (layoutType) => {
        //chat, onetoone, group, tip, tip_goal
        let _layoutType = "";
        if (layoutType !== this.state.activeRightLayout) {
            _layoutType = layoutType
        }

        this.setRightLayout(_layoutType);
    };

    setRightLayout = (layoutType) => {
        //chat, onetoone, group, tip, tip_goal
        this.setState({
            activeRightLayout: layoutType
        }, () => {
            updateVideoDimensions();
        });
    };

    setTipMessage = (message) => {
        this.setState({
            tipMessage: message
        },()=>{
            updateVideoDimensions();
        });
    };

    /**
     * @function is invoked just before mounting occurs. It is called before render(), therefore calling setState()
     * synchronously in this method will not trigger an extra rendering.
     * Generally, we recommend using the constructor() instead for initializing state
     */
    checkValidBroadcast() {
        //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
        checkValidBroadcast(this.props.location)
            .then((broadcastDetail) => {
                if (
                    decodeEncryptedIdForBroadcaster(broadcastDetail.broadcast_id) !== -1
                ) {
                    this.setState(
                        {
                            broadcast_id: decodeEncryptedIdForBroadcaster(
                                broadcastDetail.broadcast_id
                            ),
                            session_id: broadcastDetail.session_id,
                            token: broadcastDetail.token,
                            private_broadcast_id: broadcastDetail.hasOwnProperty(
                                "private_broadcast_id"
                            )
                                ? decodeEncryptedIdForBroadcaster(
                                    broadcastDetail.private_broadcast_id
                                )
                                : -1,
                            is_in_private_session: broadcastDetail.hasOwnProperty(
                                "private_broadcast_id"
                            ),
                            showLoading: true,
                        },
                        () => {
                            /**
                             * @Webservice GET Broadcast detail API
                             */

                            getData(LOGIN).then((data) => {
                                if (!isEmpty(data) && data.api_token) {
                                    this.setState({
                                        showLoading: true,
                                    });
                                    this.props.getBroadcastDetail(
                                        data.token,
                                        data.api_token,
                                        this.state.broadcast_id
                                    );
                                } else {
                                    this.props.getBroadcastDetailGuest(
                                        "",
                                        "",
                                        this.state.broadcast_id
                                    );
                                }
                            });
                        }
                    );
                } else {
                    this.navigateUserOut(
                        "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later."
                    );
                }
            })
            .catch((err) => {
                this.props.showLeftBar(); //show the leftbar
                LogException("ViewBroadcast", "checkValidBroadcast", err);
                this.navigateUserOut(
                    "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later."
                );
            });
    }

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        this.checkValidBroadcast();

        this.props.hideLeftBar(); //hide the leftbar
        this.props.hideSearchBar(); //hide the Search bar
        this.setState({otherRequestAccepted: false}); //this state is only used to identify session left message

        document.addEventListener("fullscreenchange", this.escFunction);
        document.addEventListener("webkitfullscreenchange", this.escFunction);
        document.addEventListener("mozfullscreenchange", this.escFunction);
        document.addEventListener("MSFullscreenChange", this.escFunction);
        let element = document.getElementsByClassName("modal-backdrop");
        element.length > 0 && (element[0].style.display = "none");

        this.setState({
            wallet_balance: this.props.moneyblox.wallet_balance,
        });
        this.showRequestLiveChat();

        window.addEventListener('resize', () => {

            this.setState({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
            }, () => {
                updateVideoDimensions();
            })
        })
    }

    /**
     * @function This method is called when a component is being removed from the DOM
     * so we have to unsubscribe to all events & disconnect from OT Session
     */
    componentWillUnmount() {
        this.endSession();
        unsubscribeToFireStore(this.state.broadcast_id);

        document.addEventListener("fullscreenchange", this.escFunction);
        document.addEventListener("webkitfullscreenchange", this.escFunction);
        document.addEventListener("mozfullscreenchange", this.escFunction);
        document.addEventListener("MSFullscreenChange", this.escFunction);
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        //handle request availability request
        if (
            nextProps.availability &&
            nextProps.availability.availabilityBroadcastSuccess
        ) {
            vuepayAlert(
                "success",
                nextProps.availability.availabilityBroadcast.success.message
            );
            nextProps.hideRequestAvailableBroadcasterModal();
            nextProps.showAwaitingAvailableBroadcasterModal();
            nextProps.resetAvaibilityBroadcast();

        } else if (
            nextProps.availability &&
            nextProps.availability.availabilityBroadcastError &&
            nextProps.availability.availabilityBroadcast
        ) {
            vuepayAlert(
                "error",
                nextProps.availability.availabilityBroadcast.response.error.message
            );
            nextProps.hideRequestAvailableBroadcasterModal();

        }

        //pull in the broadcast details & check if the url is not forged from the user
        if (
            nextProps.broadcaster_detail_management &&
            nextProps.broadcaster_detail_management.broadcastDetail != null
        ) {
            if (
                nextProps.broadcaster_detail_management.broadcastDetail.hasOwnProperty(
                    "data"
                ) &&
                nextProps.broadcaster_detail_management.broadcastDetail.data.length > 0
            ) {
                if (
                    nextProps.broadcaster_detail_management.broadcastDetail.data[0].hasOwnProperty(
                        "broadcast_end_at"
                    ) &&
                    nextProps.broadcaster_detail_management.broadcastDetail.data[0]
                        .broadcast_end_at !== null &&
                    this.state.private_broadcast_id === -1
                ) {
                    vuepayAlert("error", "This broadcast is ended");
                    this.props.history.push("/dashboard");
                    return;
                }

                this.setState(
                    {
                        broadcaster: formatBroadacastJson(
                            nextProps.broadcaster_detail_management.broadcastDetail.data[0]
                        ),
                    },
                    () => {

                        let _broadcaster = this.state.broadcaster;
                        _broadcaster.broadcast[0]["broadcaster"] = this.state.broadcaster;
                        _broadcaster.broadcast[0]["tip_goal"] = this.state.broadcaster.tip_goal;

                        this.setState({
                            broadcaster: _broadcaster
                        });

                        if (!this.state.broadcaster.broadcast[0].hasOwnProperty("private")) {
                            getData(USER_DATA).then((data) => {
                                if (!isEmpty(data)) {
                                    subscribeToFireStoreForOneToOneRequest(
                                        this.state.broadcast_id,
                                        data.user_id,
                                        this.onOneToOneRequestUpdateForViewer
                                    );
                                }
                            });
                        } else {
                            if (this.state.broadcaster.broadcast[0].private.hasOwnProperty("end_at") &&
                                this.state.broadcaster.broadcast[0].private.end_at !== null
                            ) {
                                if(this.state.private_broadcast_id !== -1){
                                    vuepayAlert("error", "Private session has ended!", () => {
                                        this.props.history.push("/dashboard");
                                    });
                                }
                                return;
                            }
                        }
                    }
                );
            } else if (
                nextProps.broadcaster_detail_management.broadcastDetail.error != null
            ) {
                //get the user out of this screen
                this.navigateUserOut(
                    nextProps.broadcaster_detail_management.broadcastDetail.error.message
                );
            }

            this.props.resetBroadcastDetail();
        }

        //Join broadcast response - to get latest session id and token
        if (
            nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("payload") &&
            nextProps.join_broadcast.payload !== null
        ) {
            if (nextProps.join_broadcast.isSuccess) {
                updateJWTToken(nextProps.join_broadcast.payload, () => {
                    this.props.initializeTokBox(nextProps.join_broadcast.payload.data);
                    const broadcastID = getEncryptedIdForBroadcaster(
                        this.state.tempNewBroadcastId
                    );
                    removeAllModalPopUps();
                    const path = `/view/broadcast?session_id=${nextProps.join_broadcast.payload.data.session_id}&broadcast_id=${broadcastID}&token=${nextProps.join_broadcast.payload.data.token}`;

                    this.props.history.push(path, {
                        state: {
                            broadcaster: this.state.broadcaster,
                            sessionDetail: nextProps.join_broadcast.payload,
                        },
                    });
                    window.location.href = path;
                });
            } else if (nextProps.join_broadcast.isError) {
                vuepayAlert("error", nextProps.join_broadcast.payload.message);
            }
            this.props.resetJoinBroadcast();
        }

        //Join broadcast response - to get latest session id and token
        if (
            nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("privateBroadcastPayload") &&
            nextProps.join_broadcast.privateBroadcastPayload !== null
        ) {
            if (nextProps.join_broadcast.isSuccess) {
                const payload = nextProps.join_broadcast.privateBroadcastPayload;
                updateJWTToken(nextProps.join_broadcast.privateBroadcastPayload, () => {
                    this.props.initializeTokBox(payload.data);
                    removeAllModalPopUps();
                    const broadcastID = getEncryptedIdForBroadcaster(
                        this.state.broadcast_id
                    );
                    const private_broadcast_id = getEncryptedIdForBroadcaster(
                        this.state.tempNewBroadcastId
                    );
                    // const broadcastID = getEncryptedIdForBroadcaster(this.state.tempNewBroadcastId);
                    if (
                        payload !== null &&
                        payload.hasOwnProperty("data") &&
                        payload.data !== null
                    ) {
                        const path = `/view/broadcast?session_id=${payload.data.session_id}&broadcast_id=${broadcastID}&token=${payload.data.token}&private_broadcast_id=${private_broadcast_id}`;
                        this.props.history.push(path, {
                            broadcaster: this.state.broadcaster,
                            sessionDetail: nextProps.join_broadcast.payload,
                            is_in_private_session: true,
                        });
                        window.location.href = path;
                    }
                });
            } else if (nextProps.join_broadcast.isError) {
                vuepayAlert(
                    "error",
                    nextProps.join_broadcast.privateBroadcastPayload.message
                );
            }
            this.props.resetJoinPrivateBroadcast();
        }

        if (
            nextProps.hasOwnProperty("charge_Viewer") &&
            nextProps.charge_Viewer !== null &&
            nextProps.charge_Viewer.hasOwnProperty("payload") &&
            nextProps.charge_Viewer.payload !== null
        ) {
            const payload = nextProps.charge_Viewer.payload;
            if (nextProps.charge_Viewer.isError) {
                vuepayAlert("error", payload.message);

                if (
                    payload.error_code === 1005 ||
                    payload.error_code === 401 ||
                    payload.error_code === 400
                ) {
                    if (!this.props.moneyblox.isVisible) {
                        this.disconnectOTSession();
                        this.props.showMoneyBloxModal();
                    }
                    this.setState({
                        isTransactionPending: true,
                        subscriberAudio: false,
                        video: false,
                        audio: false,
                    });
                } else if (
                    payload.message === "The broadcast is not yet started." ||
                    payload.message ===
                    "The private session you are charging for is not yet started."
                ) {
                    // setTimeout(() => {
                    //     //charge viewer for broadcast after 3 sec of this error
                    //     this.setUpChargeForViewer()
                    // }, 3000)
                } else if (
                    payload.message ===
                    "The private session you are charging for has been ended." ||
                    payload.message === "The broadcast is ended."
                ) {
                    this.disconnectOTSession();
                } else if (
                    payload.status_code === 422 ||
                    payload.message === "Login into MoneyBlox account"
                ) {
                    this.disconnectOTSession();
                    this.props.showMoneyBloxModal();
                }
            } else if (nextProps.charge_Viewer.isSuccess) {
                this.setState({
                    isTransactionPending: false,
                    subscriberAudio: true,
                    video: true,
                    audio: true,
                    wallet_balance: payload.success.wallet_balance,
                });
            }
            this.props.resetChargeViewer();
        }

        if (this.props.moneyblox.isVisible !== nextProps.moneyblox.isVisible) {
            if (!nextProps.moneyblox.isVisible && this.state.isTransactionPending) {
                getMoneyBloxCurrentWalletBalance((wallet_balance) => {
                    if (wallet_balance !== "0.00") {
                        this.setUpChargeForViewer("getMoneyBloxCurrentWalletBalance");
                    } else {
                        this.disconnectOTSession();
                        this.props.hideMoneyBloxModal();
                    }
                });

                // this.setUpChargeForViewer()
            }
            if (nextProps.moneyblox.isVisible) {
                startKickOutCountdownTimer(() => {
                    this.disconnectOTSession();
                });
            } else {
                endKickOutCountDownTimer();
            }
        }

        //Follow - unFollow
        if (
            nextProps.following &&
            nextProps.following.follow_unfollow_data != null &&
            nextProps.following.follow_unfollow_data.hasOwnProperty("success") &&
            !nextProps.following.isFetching &&
            nextProps.following.isSuccess
        ) {
            this.props.resetFollowUnFollowData();
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    this.props.getFollowingList(data.token, data.api_token, "", "");
                }
            });
            this.state.broadcaster.is_following = !this.state.broadcaster
                .is_following;
        }

        if (nextProps.tip && nextProps.tip.tipSendResponse) {

            if (nextProps.tip.tipSendResponse.error && parseInt(nextProps.tip.tipSendResponse.error.status_code) === 422) {
                vuepayAlert("error", nextProps.tip.tipSendResponse.error.message);
            } else if (nextProps.tip.tipSendResponse.success && parseInt(nextProps.tip.tipSendResponse.success.status_code) === 200) {
                this.props.showTipResponseModal();
                this.setState({
                    tipMessage: nextProps.tip.tipSendResponse.success.message,
                }, () => {
                    //tip is successfully send to the broadcaster account lets send him a direct message
                    getData(USER_DATA).then((data) => {
                        if (!isEmpty(data)) {
                            this.otSession.current.sessionHelper.session.signal({
                                data: `${data.username} tipped ${this.state.tipAmountSend}`,
                                type: "VuePay-tipping",
                            });
                        }
                    });

                });
            }
            this.props.resetTip();
        }

        if (nextProps.tip && nextProps.tip.tipGoalSendResponse) {

            if (nextProps.tip.tipGoalSendResponse.error && parseInt(nextProps.tip.tipGoalSendResponse.error.status_code) === 422) {
                vuepayAlert("error", nextProps.tip.tipGoalSendResponse.error.message);
            } else if (nextProps.tip.tipGoalSendResponse.success && parseInt(nextProps.tip.tipGoalSendResponse.success.status_code) === 200) {
                this.setState({
                    tipGoalMessage: nextProps.tip.tipGoalSendResponse.success,
                }, () => {
                    //tip is successfully send to the broadcaster account lets send him a direct message
                    getData(USER_DATA).then((data) => {
                        if (!isEmpty(data)) {
                            this.otSession.current.sessionHelper.session.signal({
                                data: `${data.username} contributed ${this.state.tipAmountSend} to the like goal`,
                                type: "VuePay",
                            });
                        }
                    });
                });
            }
            this.props.resetTipForTipGoal();
        }

        if (
            this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance
        ) {

            this.setState({
                wallet_balance: nextProps.moneyblox.wallet_balance,
            });
        }

        //MoneyBlox
        if (
            nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null
        ) {

            this.setState({
                wallet_balance: this.props.moneyblox.wallet_balance,
            });
        }

        //Tip goal regarding data from store
        if (this.state.broadcaster &&
            this.state.broadcaster.hasOwnProperty("tip_goal") &&
            Array.isArray(this.state.broadcaster.tip_goal) &&
            this.state.broadcaster.tip_goal.length > 0) {

            if (this.state.tipGoalPurpose === null) {
                /**
                 * @business_rule
                 * listener for tip_goal
                 */
                subscribeToFireStoreForTipGoal(
                    this.state.broadcaster.broadcast[0].id.toString(),
                    this.state.broadcaster.tip_goal[0].tip_goal_id,
                    this.onRequestTipGoalData
                );
            }

            this.setState({
                tipGoalPurpose: this.state.broadcaster.tip_goal[0].purpose,
            });
            this.setState({
                tipGoalId: this.state.broadcaster.tip_goal[0].id,
            });
        }
    }

    updateTipGoalProgress = (progress) => {

        let tipGoalProgress = document.getElementById('tip-goal-progress');
        if (tipGoalProgress) {
            document.getElementById('tip-goal-progress').style.display = "block";
        }
        let svgPath = document.getElementById('heart-path');
        if (svgPath) {
            let path = new ProgressBar.Path(svgPath, {
                color: '#FCB03C',
                duration: 3000,
                easing: 'easeInOut'
            });

            path.animate(progress);
        }
    };

    onRequestTipGoalData = (querySnapshot) => {
        if (querySnapshot.exists) {
            this.setState({
                tipGoalData: querySnapshot.data(),
            });

            if (this.state.tipGoalData && this.state.tipGoalData.hasOwnProperty("percentage") && this.state.tipGoalData.percentage !== null) {
                //reset the progress to zero
                let progress = (this.state.tipGoalData.percentage / 100) > 1 ? 1 : this.state.tipGoalData.percentage / 100;
                this.updateTipGoalProgress(progress);
            }
        }
    };

    disconnectOTSession = () => {
        const modal = document.getElementById("end-broadcast-session");
        hideModal(modal);

        if (this.otSession && this.otSession.current !== null) {
            this.otSession.current.sessionHelper.session.disconnect();
        }

        // Cancel all the request (if) sent to broadcaster
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                cancelPaidGroupRequest(
                    `${this.state.broadcaster.broadcast[0].id}`,
                    data.user_id,
                    () => {
                    }
                );
                cancelPrivateRequest(
                    `${this.state.broadcaster.broadcast[0].id}`,
                    data.user_id,
                    () => {
                    }
                );
            }
        });
        this.props.history.push("/dashboard");
    };

    endSession = () => {
        if (this.otSession && this.otSession.current !== null) {
            this.otSession.current.sessionHelper.session.disconnect();
        }
    };

    onErrorReceived = (err) => {
        this.navigateUserOut(
            "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later."
        );
    };

    navigateUserOut = (message) => {
        vuepayAlert("error", message, () => {
            this.props.history.push("/dashboard");
        });
    };

    onOneToOneRequestUpdateForViewer = (documentSnapshot) => {
        if (
            documentSnapshot.exists &&
            !this.state.broadcaster.broadcast[0].hasOwnProperty("private") &&
            !this.state.isPrivateRequestReceived
        ) {
            const requestData = documentSnapshot.data();
            if (requestData && requestData.from === "broadcaster") {
                this.setState(
                    {
                        isPrivateRequestReceived: true,
                    },
                    () => {
                        this.togglePrivateSessionInviteModal();
                        unsubscribeToFireStore(this.state.broadcast_id);
                    }
                );
            }
        }
    };

    onSubscribe = () => {
        vuePayLog("StartViewBroadcast", "onInit");
        updateVideoDimensions();
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                //send messages if the user is not guest
                if (!this.state.isMessageSend) {
                    this.setState(
                        {
                            isMessageSend: true,
                        },
                        () => [
                            this.otSession.current.sessionHelper.session.signal({
                                data: "has joined the broadcast",
                                type: "Viewer",
                            }),
                        ]
                    );
                }
            }
        });
    };

    getStatsDetails = (data) => {
        if (data && data.video) {
            const totalPackets = data.video.packetsLost + data.video.packetsReceived;
            const ratio = data.video.packetsLost / totalPackets;
            if (ratio >= 0.03) {
                if (!this.state.isPoorConnectivity) {
                    this.setState({
                        isPoorConnectivity: true,
                    });
                }
            } else {
                if (this.state.isPoorConnectivity) {
                    this.setState({
                        isPoorConnectivity: false,
                    });
                }
            }
        }
    };

    setOTSession = (session) => {
        if (!this.state.showSubscriber) {

            this.setState({
                sessionHelper: session,
            });

            this.setState({
                showSubscriber: true,
            });

            this.otSession.current.sessionHelper.session.on(
                "connectionCreated",
                (event) => {

                }
            );

            this.otSession.current.sessionHelper.session.on(
                "sessionDisconnected",
                (event) => {
                    if (event.hasOwnProperty("reason") && event.reason === "forceDisconnected") {
                        this.endSession();
                        unsubscribeToFireStore(this.state.broadcast_id);
                        vuepayAlert(
                            "error",
                            "This broadcaster has kicked you out of the session"
                        );
                        this.props.history.push("/dashboard");
                    }
                }
            );

            this.otSession.current.sessionHelper.session.on(
                "connectionDestroyed",
                (event) => {
                    const broadcast_id = this.state.broadcaster.broadcast[0].id;
                    const connectionData = parseUserDataFromConnection(
                        event.connection.data
                    );

                    if (connectionData && connectionData.type === "broadcaster") {

                        //setLoading()
                        this.setState({
                            showLoading: true,
                        });

                        if (event.reason === "clientDisconnected") {

                            ;
                            // Check if "ChangeBroadcast" node exist on firestore for given broadcast id
                            getChangeBroadcastStatus(
                                ""+broadcast_id,
                                false,
                                (data) => {

                                    if (data !== undefined) {
                                        let broadcaster = this.state.broadcaster;
                                        broadcaster.broadcast[0].session_title = data.session_title;
                                        broadcaster.broadcast[0].session_description =
                                            data.session_description;
                                        broadcaster.broadcast[0].broadcast_type =
                                            data.broadcast_type;
                                        broadcaster.broadcast[0].one_to_one_session_allow =
                                            data.one_to_one_session_allow;
                                        broadcaster.broadcast[0].one_to_one_session_price =
                                            data.one_to_one_session_price;
                                        broadcaster.broadcast[0].group_session_price =
                                            data.group_session_price;
                                        broadcaster.broadcast[0].id = data.broadcast_id;
                                        let title =
                                            data.broadcast_type === "paid"
                                                ? "The broadcaster is starting a paid session"
                                                : "The broadcaster is starting a free session";

                                        //changeBroadcastHappened()
                                        this.setState(
                                            {
                                                tempNewBroadcastId: data.broadcast_id,
                                                broadcaster: broadcaster,
                                                broadcastModalTitle: title,
                                                showLoading: false,
                                            },
                                            () => {
                                                this.toggleJoinBroadcastModal();
                                            }
                                        );
                                    } else {
                                        // Check if "paidgroup" node exist on firestore for given broadcast id
                                        getPaidGroupRequestStatus(
                                            ""+broadcast_id,
                                            (data) => {

                                                if (data !== undefined) {
                                                    let title = this.state.isPaidGroupRequestSent
                                                        ? "Group request accepted"
                                                        : "The broadcaster is starting a paid session";
                                                    let broadcaster = this.state.broadcaster;
                                                    broadcaster.broadcast[0].broadcast_type = "paid";
                                                    broadcaster.broadcast[0].group_session_price = data.price;
                                                    broadcaster.broadcast[0].id = data.broadcast_id;
                                                    this.setState({
                                                        tempNewBroadcastId: data.broadcast_id,
                                                        broadcaster: broadcaster,
                                                        broadcastModalTitle: title,
                                                        showLoading: false,
                                                    },() => {
                                                        this.toggleJoinBroadcastModal();
                                                    });
                                                } else {
                                                    // Check if "private_session" node exist on firestore for given broadcast id
                                                    getPrivateSessionRequestStatus(
                                                        ""+broadcast_id,
                                                        (data) => {

                                                            //unsubscribeToFireStore(this.state.broadcast_id);
                                                            if (data !== undefined) {
                                                                getData(USER_DATA).then((user_data) => {
                                                                    if (!isEmpty(user_data)) {
                                                                        // data.viewer_id === user_data.user_id &&
                                                                        if (
                                                                            !this.state.broadcaster.broadcast[0].hasOwnProperty(
                                                                                "private"
                                                                            )
                                                                        ) {
                                                                            getOneToOneRequestStatus(
                                                                                `${this.state.broadcaster.broadcast[0].id}`,
                                                                                user_data.user_id,
                                                                                (jsonData) => {

                                                                                    
                                                                                    if (jsonData !== undefined &&
                                                                                        jsonData.status === 1
                                                                                    ) {
                                                                                        if (
                                                                                            this.state.isPrivateRequestSent
                                                                                        ) {
                                                                                            const title =
                                                                                                "Private request accepted";
                                                                                            const broadcaster = this.state
                                                                                                .broadcaster;
                                                                                            broadcaster.broadcast[0].id =
                                                                                                data.broadcast_id;
                                                                                            this.setState(
                                                                                                {
                                                                                                    tempNewBroadcastId:
                                                                                                    data.broadcast_id,
                                                                                                    broadcaster: broadcaster,
                                                                                                    broadcastModalTitle: title,
                                                                                                    isPrivateRequestAccepted: true,
                                                                                                    showLoading: false,
                                                                                                },
                                                                                                () => {
                                                                                                    this.toggleJoinBroadcastModal();
                                                                                                }
                                                                                            );
                                                                                        } else {
                                                                                            this.joinPrivateBroadcastReceived(
                                                                                                data.id
                                                                                            );
                                                                                        }
                                                                                    } else {
                                                                                        //Check if private request accepted by self is processed by broadcaster
                                                                                        this.endSession();
                                                                                        this.setState(
                                                                                            {
                                                                                                showLoading: false,
                                                                                            },
                                                                                            () => {
                                                                                                this.setState({
                                                                                                    otherRequestAccepted: true,
                                                                                                });
                                                                                                this.showBroadcasterLeftPopUp();
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                }
                                                                            );

                                                                            // }
                                                                        } else {
                                                                            // Broadcaster has accepted other's private session request
                                                                            /*
                                                                                                      Comments:
                                                                                                      bug fix: viewer on Web doesn't get message if the broadcast is ended

                                                                                                      this.endSession() */
                                                                            this.setState(
                                                                                {
                                                                                    showLoading: false,
                                                                                },
                                                                                () => {
                                                                                    this.showBroadcasterLeftPopUp();
                                                                                }
                                                                            );
                                                                        }
                                                                    }
                                                                });
                                                            } else {
                                                                //Broadcaster has ended the session
                                                                this.endSession();
                                                                this.setState(
                                                                    {
                                                                        showLoading: false,
                                                                    },
                                                                    () => {
                                                                        this.showBroadcasterLeftPopUp();
                                                                    }
                                                                );
                                                            }
                                                        }
                                                    );
                                                }
                                            }
                                        );
                                    }
                                }
                            );
                        } else if (event.reason === "forceDisconnected") {
                            //forceDisconnected()
                            this.setState(
                                {
                                    showLoading: false,
                                },
                                () => {
                                    this.showBroadcasterLeftPopUp();
                                }
                            );
                        }
                    }
                }
            );

            this.otSession.current.sessionHelper.session.on("signal", (event) => {
                let signalArray = this.state.signalArray;
                signalArray.push(getSignalObject(event));
                this.setState({
                    signalArray: signalArray,
                });
            });
        }
    };

    showBroadcasterLeftPopUp = () => {
        removeAllModalPopUps();
        this.setState(
            {
                //broadcasterLeftSession: true,
                modal: false,
            },
            () => {
                //this.toggleEndSessionModal();
            }
        );
        unsubscribeToFireStore(this.state.broadcast_id);

        let message =  "Broadcaster has left the session";
        if(this.state.otherRequestAccepted){
            message = "Broadcaster has left the session and is busy in private session"
        }

        vuepayAlert("success",message);
        this.disconnectOTSession();
    };

    toggleEndSessionModal = (e) => {
        const modal = document.getElementById("end-broadcast-session");
        this.setState(
            {
                modal: !this.state.modal,
            },
            () => {
                this.state.modal ? showModal(modal) : hideModal(modal);
            }
        );
    };

    toggleReportBroadcastModal = () => {
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                const modal = document.getElementById("report-broadcast-modal");
                this.setState(
                    {
                        reportBroadcastModal: !this.state.reportBroadcastModal,
                    },
                    () => {
                        this.state.reportBroadcastModal
                            ? showModal(modal)
                            : hideModal(modal);
                    }
                );
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {
                        basePath: this.props.history.location.pathname,
                        search: this.props.history.location.search,
                    },
                });
            }
        });
    };

    toggleInviteForSessionModal = () => {
        const modal = document.getElementById("invite-for-session");
        this.setState(
            {
                inviteSessionModal: !this.state.inviteSessionModal,
            },
            () => {
                this.state.inviteSessionModal ? showModal(modal) : hideModal(modal);
            }
        );
    };

    togglePrivateSessionInviteModal = (ev) => {
        if (ev) {
            ev.preventDefault();
        }
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                const modal = document.getElementById(
                    "private-session-invite-confirmation"
                );
                this.setState(
                    {
                        privateSessionInviteModal: !this.state.privateSessionInviteModal,
                    },
                    () => {
                        this.state.privateSessionInviteModal
                            ? showModal(modal)
                            : hideModal(modal);
                    }
                );
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {
                        basePath: this.props.history.location.pathname,
                        search: this.props.history.location.search,
                    },
                });
            }
        });
    };

    togglePaidGroupRequestModal = () => {
        getData(USER_DATA).then((data) => {
            if (!isEmpty(data)) {
                const modal = document.getElementById("paid-group-request-modal");
                this.setState(
                    {
                        paidGroupRequestModal: !this.state.paidGroupRequestModal,
                    },
                    () => {
                        this.state.paidGroupRequestModal
                            ? showModal(modal)
                            : hideModal(modal);
                    }
                );
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {
                        basePath: this.props.history.location.pathname,
                        search: this.props.history.location.search,
                    },
                });
            }
        });
    };

    toggleJoinBroadcastModal = () => {
        const modal = document.getElementById("join-broadcast-confirmation");
        this.setState(
            {
                joinBroadcastModal: !this.state.joinBroadcastModal,
            },
            () => {
                this.state.joinBroadcastModal ? showModal(modal) : hideModal(modal);
            }
        );
    };

    togglePrivateRequestStatus = () => {
        this.setState(
            {
                isPrivateRequestSent: !this.state.isPrivateRequestSent,
            },
            () => {
            }
        );
    };

    togglePaidGroupRequestStatus = () => {
        this.setState(
            {
                isPaidGroupRequestSent: !this.state.isPaidGroupRequestSent,
            },
            () => {
            }
        );
    };

    togglePrivateRequestReceivedStatus = () => {
        this.setState(
            {
                isPrivateRequestReceived: !this.state.isPrivateRequestReceived,
            },
            () => {
            }
        );
    };

    requestFullScreen = () => {

        const video = document.getElementsByClassName("video-container")[0];

        this.setState({isFullScreen: true}, () => {
            requestFullScreen(video);
            video.style.width = "100%";
            setTimeout(() => {
                this.setState(
                    {
                        fullScreenHeight: window.innerHeight,
                    },
                    () => {
                        this.toggleFull();
                    }
                );
            }, 1000);
        });
    };

    cancelFullScreen = () => {
        const video = document.getElementsByClassName("video-container")[0];

        this.setState({isFullScreen: false}, () => {
            cancelFullScreen(video);
            video.style.width = "100%";
            if (this.state.private_broadcast_id !== -1) {
                document.getElementsByClassName("OTPublisherContainer")[0].style.height = "520px";
            } else {
                document.getElementsByClassName("OTSubscriberContainer")[0].style.height = "520px";
            }
            document.exitFullscreen();
        });
    }

    toggleFull = () => {
        if (this.state.togglePubSubState) {
            if (this.state.private_broadcast_id !== -1) {
                let chat_window = document.getElementById("chat-window");
                let sub_id = document.getElementById("sub-id");
                sub_id.className = "chat-window";
                document.getElementsByClassName(
                    "OTSubscriberContainer"
                )[0].style.height = "150px";
                chat_window.className = "";
                document.getElementsByClassName(
                    "OTPublisherContainer"
                )[0].style.height = `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`;

                this.setState({isPrivateSession: false});
            }
        } else {
            if (this.state.private_broadcast_id !== -1) {
                let chat_window = document.getElementById("chat-window");
                let sub_id = document.getElementById("sub-id");
                sub_id.className = "";
                document.getElementsByClassName(
                    "OTSubscriberContainer"
                )[0].style.height = `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`;
                chat_window.className = "chat-window";
                document.getElementsByClassName(
                    "OTPublisherContainer"
                )[0].style.height = "150px";

                this.setState({isPrivateSession: true});
            } else {
                //let chat_window = document.getElementById("chat-window");
                let sub_id = document.getElementById("sub-id");
                sub_id.className = "";
                document.getElementsByClassName(
                    "OTSubscriberContainer"
                )[0].style.height = `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`;
            }
        }
    };

    togglePubSub = () => {
        this.setState({togglePubSubState: !this.state.togglePubSubState});
        if (!this.state.togglePubSubState) {
            let chat_window = document.getElementById("chat-window");
            let sub_id = document.getElementById("sub-id");
            sub_id.className = "chat-window";
            document.getElementsByClassName("OTSubscriberContainer")[0].style.height =
                "150px";
            chat_window.className = "";
            document.getElementsByClassName(
                "OTPublisherContainer"
            )[0].style.height = `${
                document.getElementsByClassName("video-container")[0].offsetHeight
                }px`;

            this.setState({isPrivateSession: false});
        } else {
            let chat_window = document.getElementById("chat-window");
            let sub_id = document.getElementById("sub-id");
            sub_id.className = "";
            document.getElementsByClassName(
                "OTSubscriberContainer"
            )[0].style.height = `${
                document.getElementsByClassName("video-container")[0].offsetHeight
                }px`;
            chat_window.className = "chat-window";
            document.getElementsByClassName("OTPublisherContainer")[0].style.height =
                "150px";

            this.setState({isPrivateSession: true});
        }
    };

    escFunction = (event) => {
        if (
            !document.fullscreenElement &&
            !document.webkitIsFullScreen &&
            !document.mozFullScreen &&
            !document.msFullscreenElement
        ) {
            this.setState({isFullScreen: false}, () => {
                setTimeout(() => {
                    this.toggleFull();
                }, 1000);
            });
        }
    };

    apiCallForJoinBroadcast = (broadcast_id) => {
        getData(LOGIN).then((data) => {
            const jsonData = {
                device: this.props.device,
            };
            if (!isEmpty(data)) {
                this.props.joinBroadcast(
                    data.token,
                    data.api_token,
                    broadcast_id,
                    jsonData
                );
            }
        });
    };

    joinPrivateBroadcastReceived = (private_session_id) => {
        getData(LOGIN).then((data) => {
            const jsonData = {
                device: this.props.device,
            };
            if (!isEmpty(data)) {
                setTimeout(()=>{
                    this.setState({
                        showLoading: false,
                    });

                    this.props.joinPrivateBroadcast(
                        data.token,
                        data.api_token,
                        private_session_id,
                        jsonData
                    );
                },2000);
                //delay of 2 secs for the broadcaster to enter the room
            }
        });
    };

    toggleVideo() {
        // Only if Initial publishing encountered an error
        if (this.state.is_in_private_session && this.state.isPublishingError) {
            this.setState(
                {
                    is_in_private_session: false,
                },
                () => {
                    this.setState({
                        is_in_private_session: true,
                    });
                }
            );
        }

        this.setState({
            video: !this.state.video,
        });
    }

    toggleAudio() {
        this.setState({
            audio: !this.state.audio,
        });
    }

    setElapsedTime = (time) => {
        this.setState(
            {
                elapsed_time: time,
            },
            () => {
                /**
                 * @business_rule
                 * check if the seconds count is 59 then
                 */
                const timeArray = time.split(":"),
                    seconds = timeArray[2];

                if (parseInt(seconds) % 60 === 0) {
                    /**
                     * @Webservice Charge Viewer for a private or group session
                     */
                    this.setUpChargeForViewer("setElapsedTime");
                }
            }
        );
    };

    setUpChargeForViewer = (from) => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let jsonData = {
                    device: this.props.device,
                    moneyblox: getWalletUserSessionDetails(this.props),
                };

                if (from !== "constructor") {
                    jsonData.moneyblox.wallet_balance =
                        parseFloat(this.state.wallet_balance.toString()) * 100;
                } else {
                    jsonData.moneyblox.wallet_balance =
                        parseFloat(jsonData.moneyblox.wallet_balance) * 100;
                }
                if (
                    this.state.broadcaster.broadcast[0].hasOwnProperty("private") &&
                    this.state.broadcaster.broadcast[0].broadcast_type !== "free"
                ) {
                    jsonData.charge = this.state.broadcaster.broadcast[0].one_to_one_session_price;
                    jsonData.type = "private";
                    jsonData.private_session_id = this.state.broadcaster.broadcast[0].private.id;
                    jsonData.broadcast_id = this.state.broadcaster.broadcast[0].id;

                    this.props.chargeViewerForSession(
                        data.token,
                        data.api_token,
                        jsonData
                    );
                } else if (this.state.broadcaster.broadcast[0].broadcast_type === "paid") {
                    jsonData.charge = this.state.broadcaster.broadcast[0].group_session_price;
                    jsonData.type = "group";
                    jsonData.broadcast_id = this.state.broadcaster.broadcast[0].id;
                    this.props.chargeViewerForSession(
                        data.token,
                        data.api_token,
                        jsonData
                    );
                }
            }
        });
    };

    clickedOnFollowUnFollow = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data) && data.api_token) {
                if (this.state.broadcaster.is_following) {
                    this.props.unFollowBroadcaster(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                } else {
                    this.props.followBroadcaster(
                        data.token,
                        data.api_token,
                        this.state.broadcaster.id
                    );
                }
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {
                        basePath: this.props.history.location.pathname,
                        search: _get(this.props, "history.location.search", ""),
                    },
                });
            }
        });
    };

    acceptedPrivateRequestReceivedByBroadcaster = () => {
        // subscribeToFireStoreForPrivateSessionUpdateByBroadcaster(this.state.broadcaster.broadcast[0].id.toString(),this.privateSessionUpdateForViewer)
    };

    privateSessionUpdateForViewer = (documentSnapshot) => {
        if (!documentSnapshot.empty) {
            if (
                documentSnapshot.docChanges.length > 0 &&
                documentSnapshot.docChanges[0].doc &&
                documentSnapshot.docChanges[0].doc.data()
            ) {
            }
        }
    };

    /**
     * @function is invoked immediately When Publisher is unable to publish due to any reason
     */
    onPublishError = (e) => {
        vuePayLog("ViewBroadcast - On Error", "onError", e);
        this.setState({
            isPublishingError: true,
        });
        if (e.name === "OT_USER_MEDIA_ACCESS_DENIED") {
            vuepayAlert(
                "error",
                "Media access denied, You wont be able to publish your video. Please allow camera and microphone access."
            );
        } else if (e.name === "OT_NO_DEVICES_FOUND") {
            vuepayAlert(
                "error",
                "No devices/accessories were found to provide the media stream(camera/microphone)."
            );
        }
    };

    // Display tip modal
    showRequestTipModal = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.setState({
                    tipGoalButtonActive: false,
                });
                this.setState({
                    tipButtonActive: true,
                });
                this.setState({
                    liveChatButtonActive: true,
                });
                this.props.showTipModal();
            } else {
                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    tipAmountSend = (amount) => {
        this.setState({
            tipAmountSend: `£ ${amount.toFixed(2)}`
        })
    };
    tipRequest = (tipAmount, screen) => {

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let requestData = {
                    amount: tipAmount,
                    broadcaster_id: this.state.broadcaster.id,
                    broadcast_id: this.state.broadcaster.broadcast[0].id,
                    initiated_screen: screen,
                    moneyblox: {
                        token: this.props.moneyblox.user_details.token,
                        api_token: this.props.moneyblox.user_details.api_token,
                    },
                    device: {
                        platform: this.props.device.platform,
                        name: this.props.device.name,
                        version: this.props.device.version,
                        ip: this.props.device.ip,
                        id: this.props.device.id,
                        app_version: this.props.device.app_version,
                        device_token: this.props.device.device_token,
                    },
                };

                this.props.sendTip(data.token, data.api_token, requestData);
                this.updateWalletBalance();
                this.props.hideTipModal();
            }
        });
    };

    tipGoalRequest = (tipAmount, screen) => {

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let requestData = {
                    amount: tipAmount,
                    broadcaster_id: this.state.broadcaster.id,
                    broadcast_id: this.state.broadcaster.broadcast[0].id,
                    tip_goal_id: this.state.tipGoalId,
                    initiated_screen: screen,
                    moneyblox: {
                        token: this.props.moneyblox.user_details.token,
                        api_token: this.props.moneyblox.user_details.api_token,
                    },
                    device: {
                        platform: this.props.device.platform,
                        name: this.props.device.name,
                        version: this.props.device.version,
                        ip: this.props.device.ip,
                        id: this.props.device.id,
                        app_version: this.props.device.app_version,
                        device_token: this.props.device.device_token,
                    },
                };

                this.props.sendTipForTipGoal(data.token, data.api_token, requestData);
                this.updateWalletBalance();
            }
        });
    };

    updateWalletBalance = () => {
        getWalletBalance()
            .then((payload) => {

                if (payload.hasOwnProperty("wallet_balance")) {
                    this.setState({
                        wallet_balance: payload.wallet_balance,
                    });

                    this.props.setWalletBalance(payload.wallet_balance);
                }
            })
            .catch((error) => {
                this.props.setWalletBalance("0.00");
                // if (!isSilentLogin) {
                //     //if not silent login then show the modal
                //     props.showMoneyBloxModal()
                // }
            });
    };

    showRequestTipGoal = () => {
        // close the other components
        this.setState({
            tipGoalButtonActive: true,
        });
        this.setState({
            tipButtonActive: false,
        });
        this.setState({
            liveChatButtonActive: false,
        });

        //check the goal value
        if (this.state.tipGoalData && this.state.tipGoalData.maximum_tip) {

            this.state.tipGoalData.maximum_tip <= 0
                ? this.setState({
                    maximumtipStatus: true,
                })
                : this.setState({
                    maximumtipStatus: false,
                });
        }
    };

    showRequestLiveChat = () => {
        this.setState({
            tipGoalButtonActive: false,
        });
        this.setState({
            tipButtonActive: false,
        });
        this.setState({
            liveChatButtonActive: true,
        });
    };

    hideRequestTip = () => {
        this.setState({
            tipGoalButtonActive: false,
        });
        this.setState({
            tipButtonActive: false,
        });
        this.setState({
            liveChatButtonActive: true,
        });
    };

    hideRequestTipGoal = () => {
        this.setState({
            tipGoalButtonActive: false,
        });
        this.setState({
            tipButtonActive: false,
        });
        this.setState({
            liveChatButtonActive: true,
        });
    };

    tipAgainRequestTipGoal = () => {
        this.setState({
            tipGoalMessage: null,
        });
        this.setState({
            tipGoalButtonActive: true,
        });
        this.setState({
            tipButtonActive: false,
        });
        this.setState({
            liveChatButtonActive: true,
        });
    };

    getClassName = (key)=>{
        if(key === "video-container"){
            if(this.state.innerWidth > 0 && this.state.innerWidth <= 1300){
                return className("video-container viewer-video-container col-xl-12")
            }else{
                return className("video-container viewer-video-container", {
                    "col-xl-8": this.state.activeRightLayout !== "",
                    "col-xl-12": this.state.activeRightLayout === ""
                })
            }
        }
    }

    render() {
        const videoClass = className("btn-controls", "video", {
                active: this.state.video,
            }),
            audioClass = className("btn-controls", "volume", {
                active: this.state.audio,
            }),
            cameraToggle = className("btn-controls", "cameraToggle", {
                active: this.state.togglePubSub,
            });

        const pubheight = this.state.isPrivateSession
            ? "150px"
            : document.getElementsByClassName("video-container")[0] !== undefined
                ? `${
                    document.getElementsByClassName("video-container")[0].offsetHeight
                    }px`
                : "300px";
        return (
            <div>
                <AwaitingModal
                    showAwaitingModalFlag={this.props.showAwaitingModalFlag}
                    hideAwaitingModal={this.props.hideAwaitingAvailableBroadcasterModal}
                />

                {this.state.broadcaster && (
                    <ExitSessionModal
                        toggleEndSessionModal={this.toggleEndSessionModal}
                        disconnectOTSession={this.disconnectOTSession}
                        broadcaster={this.state.broadcaster}
                        hideCrossButton={this.state.broadcasterLeftSession}
                        otherRequestAccepted={this.state.otherRequestAccepted}
                        broadcasterLeftSession={this.state.broadcasterLeftSession}
                    />
                )}

                {this.state.broadcaster && (
                    <PrivateSessionInviteModal
                        togglePrivateSessionInviteModal={
                            this.togglePrivateSessionInviteModal
                        }
                        broadcaster={this.state.broadcaster}
                        togglePrivateRequestStatus={this.togglePrivateRequestStatus}
                        isPrivateRequestSent={this.state.isPrivateRequestSent}
                        isPrivateRequestReceived={this.state.isPrivateRequestReceived}
                        togglePrivateRequestReceivedStatus={
                            this.togglePrivateRequestReceivedStatus
                        }
                        isVisible={this.state.privateSessionInviteModal}
                        acceptedPrivateRequestReceivedByBroadcaster={
                            this.acceptedPrivateRequestReceivedByBroadcaster
                        }
                    />
                )}

                {this.state.broadcaster && (
                    <RequestForPaidGroupSessionModal
                        togglePaidGroupRequestModal={this.togglePaidGroupRequestModal}
                        broadcaster={this.state.broadcaster}
                        togglePaidGroupRequestStatus={this.togglePaidGroupRequestStatus}
                        isPaidGroupRequestSent={this.state.isPaidGroupRequestSent}
                    />
                )}
                {this.state.broadcaster && (
                    <JoinBroadcastConfirmationModal
                        broadcaster={this.state.broadcaster}
                        hideCrossButton={true}
                        endCurrentSession={this.endSession}
                        disconnectOTSession={this.disconnectOTSession}
                        isPrivateSession={this.state.isPrivateRequestAccepted}
                        title={this.state.broadcastModalTitle}
                        toggleJoinBroadcastModal={this.toggleJoinBroadcastModal}
                        isVisbile={this.state.joinBroadcastModal}
                    />
                )}

                <ReportBroadcastModal
                    toggleReportBroadcastModal={this.toggleReportBroadcastModal}
                    broadcast_id={this.state.broadcast_id}
                    private_broadcast_id={this.state.private_broadcast_id}
                />

                <main role="main" className="">
                    {this.state.session_id !== null && this.state.broadcaster && (
                        <div className="broadcast-container broadcasting">

                            {
                                this.state.broadcaster &&
                                this.state.broadcaster.hasOwnProperty("broadcast") &&
                                Array.isArray(this.state.broadcaster.broadcast) &&
                                this.state.broadcaster.broadcast.length > 0 &&
                                this.state.broadcaster.broadcast[0].hasOwnProperty("broadcaster") &&
                                this.state.broadcaster.broadcast[0].broadcaster.hasOwnProperty("username") &&
                                <TopSection
                                    innerWidth={this.state.innerWidth}
                                    notification={this.state.notification}
                                    broadcast={this.state.broadcaster.broadcast[0]}
                                    type={"viewer"}
                                    clickedOnFollowUnFollow={this.clickedOnFollowUnFollow}
                                    activeRightLayout={this.state.activeRightLayout}
                                    toggleRightLayout={this.toggleRightLayout}/>
                            }


                            {/*video & live chat text row starts */}
                            <div className="row video-wrapper no-padding no-margin">

                                <div className={this.getClassName("video-container")} style={{background: 'black'}}>

                                    {
                                        this.state.showLoading && (
                                            <div className="video-loading">
                                                <div style={{marginTop: "25%"}}>
                                                    <img src={assets.loading_blue} width={50} alt="loading"/>
                                                </div>
                                                <div>loading....</div>
                                            </div>
                                        )
                                    }

                                    {
                                        this.state.is_in_private_session && (
                                            <div className="chat-window" id="chat-window">
                                                <OTSession
                                                    ref={this.otSession}
                                                    apiKey={this.state.api_key}
                                                    sessionId={this.state.session_id}
                                                    token={this.state.token}
                                                    onError={this.onError}>
                                                    <Publisher
                                                        toggleEndSessionModal={this.toggleEndSessionModal}
                                                        history={this.props.history}
                                                        height={pubheight}
                                                        video={this.state.video}
                                                        audio={this.state.audio}
                                                        onInit={() => {
                                                            vuePayLog("StartBroadcast", "onInit");
                                                        }}
                                                        onPublish={() => {
                                                            vuePayLog("StartBroadcast", "onPublish");
                                                        }}
                                                        onError={this.onPublishError}
                                                    />
                                                </OTSession>
                                            </div>
                                        )
                                    }

                                    <div className="control-panel">
                                        {!this.state.is_in_private_session &&
                                        (this.state.broadcaster.broadcast[0].is_verified === 1) &&
                                        (this.state.broadcaster.broadcast[0].broadcast_type === "free") &&
                                        this.state.isFullScreen === false && (
                                            <React.Fragment>
                                                {this.state.isPaidGroupRequestSent ? (
                                                    <div
                                                        className="btn-controls users active"
                                                        onClick={this.togglePaidGroupRequestModal}
                                                    />
                                                ) : (
                                                    <div
                                                        className="btn-controls users"
                                                        onClick={this.togglePaidGroupRequestModal}
                                                    />
                                                )}
                                            </React.Fragment>
                                        )}
                                        {!this.state.is_in_private_session &&
                                        this.state.broadcaster.broadcast[0]
                                            .one_to_one_session_allow &&
                                        this.state.isFullScreen === false && (
                                            <React.Fragment>
                                                {this.state.isPrivateRequestSent ? (
                                                    <div
                                                        className="btn-controls lock active"
                                                        onClick={this.togglePrivateSessionInviteModal}
                                                    />
                                                ) : (
                                                    <div
                                                        className="btn-controls lock"
                                                        onClick={this.togglePrivateSessionInviteModal}
                                                    />
                                                )}
                                            </React.Fragment>
                                        )}

                                        {/*{*/}
                                        {/*this.state.is_in_private_session &&*/}
                                        {/*<div className={cameraToggle} onClick={this.togglePubSub} />*/}
                                        {/*}*/}

                                        {this.state.is_in_private_session && (
                                            <div
                                                className={videoClass}
                                                onClick={this.toggleVideo}
                                            />
                                        )}

                                        {this.state.is_in_private_session && (
                                            <div
                                                className={audioClass}
                                                onClick={this.toggleAudio}
                                            />
                                        )}

                                        {(this.state.broadcaster.broadcast[0].broadcast_type ===
                                            "paid" ||
                                            this.state.is_in_private_session) &&
                                        this.state.isFullScreen === false && (
                                            <div
                                                className="btn-controls card"
                                                onClick={() => {
                                                    this.props.showMoneyBloxModal();
                                                }}
                                            />
                                        )}

                                        {this.state.isFullScreen === false && (
                                            <div
                                                className="btn-controls info"
                                                onClick={this.toggleReportBroadcastModal}
                                            />
                                        )}
                                        {this.state.isFullScreen === false && (
                                            <div
                                                className="btn-controls cancel"
                                                onClick={this.toggleEndSessionModal}
                                            />
                                        )}
                                    </div>

                                    {
                                        !this.state.isFullScreen
                                            ?
                                            <div
                                                className="btn-controls fullscreen"
                                                onClick={this.requestFullScreen}
                                            />
                                            :
                                            <div
                                                className="btn-controls fullscreen active"
                                                onClick={this.cancelFullScreen}
                                            />}


                                    <OTSession
                                        ref={this.otSession}
                                        apiKey={this.state.api_key}
                                        sessionId={this.state.session_id}
                                        token={this.state.token}
                                        eventHandlers={this.sessionEvents}
                                        onError={this.onErrorReceived}
                                    >
                                        <OTStreams>
                                            <Subscriber
                                                getStatsDetails={this.getStatsDetails}
                                                history={this.props.history}
                                                audio={this.state.subscriberAudio}
                                                onSubscribe={this.onSubscribe}
                                                setOTSession={this.setOTSession}
                                                isTransactionPending={
                                                    this.state.isTransactionPending
                                                }
                                                onError={(e) =>
                                                    vuePayLog("StartBroadcast", "onError", e)
                                                }
                                                height={
                                                    document.getElementsByClassName(
                                                        "viewer-video-container"
                                                    )[0] !== undefined
                                                        ? `${
                                                            document.getElementsByClassName(
                                                                "viewer-video-container"
                                                            )[0].offsetHeight
                                                            }px`
                                                        : "300px"
                                                }
                                            ></Subscriber>
                                        </OTStreams>
                                    </OTSession>
                                </div>

                                <div className="w-100 d-block d-xl-none mt-3"></div>


                                {
                                    this.state.activeRightLayout === 'chat' &&
                                    this.otSession.current !== null && (
                                        <ChatComponent
                                            history={this.props.history}
                                            setUserData={this.setUserData}
                                            toggleInviteForSessionModal={
                                                this.toggleInviteForSessionModal
                                            }
                                            session={this.otSession.current.sessionHelper.session}
                                            signalArray={this.state.signalArray}
                                            userType={"Viewer"}
                                            actionsAllowed={false}
                                            setRightLayout={this.setRightLayout}
                                        />
                                    )
                                }

                                {
                                    (this.state.activeRightLayout === 'tip') && (
                                        <ViewerTipComponent
                                            setRightLayout={this.setRightLayout}
                                            showHeader
                                            balance={this.state.wallet_balance}
                                            addBalance={this.props.showMoneyBloxModal}
                                            tipRequest={this.tipRequest}
                                            tipAmountSend={this.tipAmountSend}

                                            showTipResponseModalFlag={this.props.showTipResponseModalFlag}
                                            hideTipResponseModal={this.props.hideTipResponseModal}
                                            setTipMessage={this.setTipMessage}
                                            tipMessage={this.state.tipMessage}
                                        />
                                    )
                                }

                                {
                                    (this.state.activeRightLayout === 'tipgoal') && (
                                        <ViewerTipGoalComponent
                                            tipGoalButtonActive={this.props.tipGoalButtonActive}
                                            hideRequestTipGoal={this.hideRequestTipGoal}
                                            balance={this.state.wallet_balance}
                                            addBalance={this.props.showMoneyBloxModal}
                                            tipGoalRequest={this.tipGoalRequest}
                                            tipGoalMessage={this.state.tipGoalMessage}
                                            tipAgainRequestTipGoal={this.tipAgainRequestTipGoal}
                                            maximumtipStatus={this.state.maximumtipStatus}
                                            tipGoalData={this.state.tipGoalData}
                                            tipGoalPurpose={this.state.tipGoalPurpose}
                                            tipAmountSend={this.tipAmountSend}
                                            setRightLayout={this.setRightLayout}
                                        />
                                    )
                                }

                            </div>
                            {/*video & live chat text row ends */}


                        </div>
                    )}
                </main>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        broadcaster_detail_management: state.broadcaster_detail_management,
        device: state.device.payload,
        join_broadcast: state.join_broadcast,
        charge_Viewer: state.charge_Viewer,
        availability: state.availability,
        showAwaitingModalFlag: state.flag.showAwaitingModal,
        moneyblox: state.moneyblox,
        following: state.following,
        tip: state.tip,
        showTipModalFlag: state.flag.showTipModalFlag,
        showTipResponseModalFlag: state.flag.showTipResponseModalFlag,
    };
}

export default connect(mapStateToProps, actions)(ViewBroadcast);
